// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3j1gA","messages":"Chat_messages__2O1KF","dateDivider":"Chat_dateDivider__3x4BV"};